import { Card, Button, message, DatePicker, Input } from "antd";
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../../../../components/CustomDataTable';
import moment from 'moment';
import strings from '../../../../strings';
import {
    SearchOutlined
} from "@ant-design/icons";
import TransferItem from "./partials/TransferItem";
import { connect } from "react-redux";

const { RangePicker } = DatePicker;
const TransferHistory = ({ user, allProducts}) => {
    const [ loading, setLoading ] = useState(false);
    const [ searchedItem, setSearchedItem ] = useState([]);
    const [ searchedValue, setSearchedValue ] = useState("");
    const [begin, setBegin] = useState(null);
    const [end, setEnd] = useState(null);
    const [ pageNumber, setPageNumber ] = useState(1);
    const [ pageSize, setPageSize ] = useState(30);
    const [ transferHistory, setTransferHistory ] = useState(false);
    const [ selectedRedemption, setSelectedHistory ] = useState(null);
    const [ showDetails, setShowDetails ] = useState(false);
    const [ showMakeTransfer, setShowMakeTransfer ] = useState(false);

    useEffect(() => {
        // handleGetTransferHx();
    }, []);

    const column = [
        {
          title: strings.productName,
          dataIndex: "product",
          render: record => {
            return <span>{record && record.name || record || "N/A"}</span>
          },
          onFilter: (value, record) => {
             if (!record["product"]) return;
            
             return record["product"].name
             .toString()
             .toLowerCase()
             .includes(value.toLowerCase()) 
             || record["product"]
             .toString()
             .toLowerCase()
             .includes(value.toLowerCase());
          },
          filterDropdown: (...props) => {
            const { clearFilters, confirm, setSelectedKeys, selectedKeys } =
              props[0];
            return (
              <div style={{ padding: 8 }}>
                <section className="filter-container">
                <Input 
                  onChange={(e) => {
                    setSelectedKeys([e.target.value])}
                  }
                  value={selectedKeys[0]}
                  // style={{ margin: "0 10px" }}
                  placeholder="Search product"
                  onPressEnter={() =>
                    confirm()
                  }
                  style={{ marginBottom: 8, display: "block" }}
                />
                <footer
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTop: "solid 1px #E6E6E6",
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, "user_id")}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                  >
                    Ok
                  </Button>
                  <Button
                    size="small"
                    style={{ width: 90 }}
                    onClick={() => handleReset(clearFilters, confirm)}
                  >
                    {strings.reset}
                  </Button>
                </footer>
              </section>
              </div>
              
            );
          },
          filterMultiple: false,
        },
        {
          title: strings.quantityTransferred,
          dataIndex: "quantity",
          render: record => (record ? <span>{record}</span> : <span>N/A</span>),
        },
        {
          title: strings.receiver,
          dataIndex: "receiver",
          render: (record, details) => {
            return (record ? <span>{record}</span> : <span>{details.stamps}</span>)
          },
          // ...this.getColumnSearchProps("active"),
        },
        {
          title: strings.status,
          dataIndex: "status",
          render: record => (record ? <span>{record}</span> : <span>N/A</span>),
        },
        {
          title: strings.transferDate,
          dataIndex: "created_at",
          render: record => (record ? <span>{moment(record).format("YYYY/MM/DD h:mm:ss A")}</span> : <span>N/A</span>),
          sorter: (a, b) => {
            return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
          },
        }
    ]

    const handleRowSelection = (record) => {
        setSelectedHistory(record);
        setShowDetails(true);
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        setSearchedItem(selectedKeys[0]);
        confirm();
    };

    const updateFilterValue = (value) => {
    
    }

    const handleReset = (clearFilters, confirm) => {
        clearFilters();
        confirm();
        setSearchedValue("");
        // setSearchedColumn("")
        setSearchedItem([]);
    };

    const handleDurationChange = function (duration, ...rest) {
        updateFilterValue("");
    
        const [begin, end] = duration;
        if (begin && end) {
        setLoading(true);
        
        // getAllMerchantLoyalty(
        //   pageNumber,
        //   pageSize,
        //   begin.format().split("T")[0],
        //   end.format().split("T")[0]
        // )
        // .then((response) => {
        //   if(response.status === 200){
        //     setRedemptionLoyalty(response.data);
        //     setLoading(false);
        //   }
        // })
        // .catch(() => {
        //   message.error(strings.errorFetchingRecord);
        // });
        } 
    };

    const handleGetTransferHx = () => {

    }

  return (
    <>
    <Card
        title={strings.transferHistory}
        loading={loading}
        extra={ 
        <div style={{ display: "flex", flexDirection: "row", gap: 5 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ margin: "0 10px" }}>{strings.reportFrom}:</span>
                <RangePicker
                    placeholder={[strings.startDate, strings.endDate]}
                    onChange={handleDurationChange}
                    allowClear="false"
                />
            </div>
            {/* <Button 
                onClick={() => setShowMakeTransfer(true)}
                 type="primary">
                    {strings.transferItem}
                </Button> */}
            </div>
        }
    >
        <CustomDataTable 
            columns={column}
            dataSource={searchedValue.length > 0 ? searchedItem : transferHistory}
            loading={loading}
            onRow={(record, rowIndex) => {
                return {
                    onClick: (event) => {
                        handleRowSelection(record);
                    },
                };
            }}
            // rowSelection={rowSelection}
        />

       
    </Card>
        {showMakeTransfer && (
            <TransferItem 
                open={showMakeTransfer}
                onCancel={()=> setShowMakeTransfer(false)}
                user={user}
                allProducts={allProducts}
            />
        )}
    </>
    
  )
}

const mapStateToProps = state => ({
  user: state.auth.user,
  supplies: state.product.supplies,
  allProducts: state.product.allProducts,
});

export default connect(mapStateToProps, {
//   getProductSupplies,
//   getProductSuppliesByDuration,
})(TransferHistory);